import React from 'react'
import AvaliacaoPerformanceFixed from '../../../components/performance/AvaliacaoPerformanceFixed'
import { usePageTitle } from '@/stores/page-title-store'

export default function AvaliacoesPage() {
  usePageTitle('Avaliações de Desempenho')

  return (

            <div className="space-y-6">
              {/* Tabbed Interface with Charts */}
              <AvaliacaoPerformanceFixed />
            </div>

  )
}
